export default "/images/cardCompanyGallery-2.png?655c7cae88070d771b376fb02faa4888";